export const DATE_FORMAT_WITH_TIME = 'MMMM D, YYYY HH:mm a';
export const DATE_FORMAT = 'MMM D, YYYY';
export const DATE_FORMAT_US = 'MM/DD/YYYY';
export const DATE_FORMAT_ISO = 'YYYY-MM-DD';
export const DATE_FORMAT_READABLE = 'MMM D, YYYY';
export const DATE_FORMAT_FULL = 'MMMM DD, YYYY';
export const FULL_MONTH_DATE_FORMAT = 'MMMM D, YYYY';
